module.exports = __webpack_public_path__ + "static/media/HerokuLogo.0b9d7822.png";


//////////////////
// WEBPACK FOOTER
// ./client/HerokuLogo.png
// module id = 265
// module chunks = 0